import { FileTypeName } from 'api/types/entity';
import { useTranslation } from 'libs/i18n';

import {
  SigningDocumentsFormType,
  FormErrors,
  getSchema,
} from '../../forms/signingDocumentsForm';
import { SigningDocumentsWrapper } from '../SigningDocumentsWrapper';

interface Props {
  canGoBack?: boolean;
  formError?: FormErrors;
  submitLoading?: boolean;
  documents: FileTypeName[];
  onGoBack?: () => void;
  onSubmit: (values: SigningDocumentsFormType) => void;
  onClickDocument: (type: FileTypeName) => void;
}

export const SigningContract = ({
  canGoBack,
  submitLoading,
  formError,
  documents,
  onGoBack,
  onSubmit,
  onClickDocument,
}: Props) => {
  const { t } = useTranslation();
  const scheme = getSchema();

  return (
    <SigningDocumentsWrapper
      canGoBack={canGoBack}
      codeFieldName="otpCode"
      documents={documents}
      initialErrors={formError}
      submitLoading={submitLoading}
      subTitle={t('onboarding.signingContract.subtitle')}
      title={t('onboarding.signingContract.title')}
      validationSchema={scheme}
      onClickDocument={onClickDocument}
      onGoBack={onGoBack}
      onSubmit={onSubmit}
    />
  );
};
